import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const TempStyledIcon = styled(BaseSvg)`
  width: 25px;
  height: 23px;
  color: #1a56db;
`

const ActionFeature = ({ title = 'Action', ...rest }: IconProps) => {
  return (
    <TempStyledIcon viewBox="0 0 28 28" title={title} {...rest}>
      <g id="Button-Link-to-New-feature" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="New-Feature-Window---Overlay"
          transform="translate(-932.000000, -245.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(928.000000, 241.000000)">
            <g id="sync-devices" transform="translate(4.500000, 4.500000)">
              <path
                d="M20.25,6.75 L20.25,7.875 L22.5,7.875 L22.5,6.75 C22.5,3.027375 19.472625,0 15.75,0 L14.625,0 L14.625,2.25 L15.75,2.25 C18.23175,2.25 20.25,4.26825 20.25,6.75 Z"
                id="Path"
              ></path>
              <path
                d="M6.75,20.25 L6.75,19.125 L4.5,19.125 L4.5,20.25 C4.5,23.972625 7.527375,27 11.25,27 L12.375,27 L12.375,24.75 L11.25,24.75 C8.76825,24.75 6.75,22.73175 6.75,20.25 Z"
                id="Path"
              ></path>
              <path
                d="M10.125,0 L2.25,0 C1.006875,0 0,1.006875 0,2.25 L0,14.625 C0,15.868125 1.006875,16.875 2.25,16.875 L10.125,16.875 C11.368125,16.875 12.375,15.868125 12.375,14.625 L12.375,2.25 C12.375,1.006875 11.368125,0 10.125,0 Z M10.125,13.5 L2.25,13.5 L2.25,3.375 L10.125,3.375 L10.125,13.5 Z"
                id="Shape"
              ></path>
              <path
                d="M24.75,10.125 L16.875,10.125 C15.631875,10.125 14.625,11.131875 14.625,12.375 L14.625,24.75 C14.625,25.993125 15.631875,27 16.875,27 L24.75,27 C25.993125,27 27,25.993125 27,24.75 L27,12.375 C27,11.131875 25.993125,10.125 24.75,10.125 Z M24.75,23.625 L16.875,23.625 L16.875,13.5 L24.75,13.5 L24.75,23.625 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </TempStyledIcon>
  )
}

ActionFeature.needsWork = true
export default ActionFeature
